import FlushAccordion from "src/SharedComponents/FlushAccordion/FlushAccordion";
import { AuraSuiteIcon } from "src/SharedComponents/Icons/Icons";
import { IAuraSoftwareSuiteLicensesInfo, IPartner, IStorageLicensesInfo } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import AuraSoftwareSuiteLicensesAssigned from "./AuraSoftwareSuiteLicensesAssigned/AuraSoftwareSuiteLicensesAssigned";
import AuraSoftwareSuiteLicensesUnassigned from "./AuraSoftwareSuiteLicensesUnassigned/AuraSoftwareSuiteLicensesUnassigned";

export interface IAuraSoftwareSuiteLicenses{
    auraSoftwareSuiteLicensesLicenses: IAuraSoftwareSuiteLicensesInfo[];
    auraTotalSoftwareSuiteLicensesLicensesCount: number;
    partner: IPartner[] | undefined;
    updateLicenses: () => void;
}

const AuraSoftwareSuiteLicenses: React.FC<IAuraSoftwareSuiteLicenses> = ({auraSoftwareSuiteLicensesLicenses,auraTotalSoftwareSuiteLicensesLicensesCount, partner, updateLicenses}) => {
    const getLicensesByPartner = (assignedToPartner: boolean) => {
        return auraSoftwareSuiteLicensesLicenses && auraSoftwareSuiteLicensesLicenses?.filter((license: IStorageLicensesInfo) => license?.isAssignedToPartner === assignedToPartner);
    }

    return(
        <>
            <>
            <FlushAccordion title={`${'Aura Software Suites'} (${auraSoftwareSuiteLicensesLicenses?.length} / ${auraTotalSoftwareSuiteLicensesLicensesCount})`} id="AuraSoftwareSuiteLicenses" titleElement={<AuraSuiteIcon />} marginRightImage="25px">
                <div className="pt-4">
                    {
                        getLicensesByPartner(true).length > 0 ? <AuraSoftwareSuiteLicensesAssigned auraSoftwareSuiteLicenses={getLicensesByPartner(true)} /> : <></>
                    }
                    {
                        getLicensesByPartner(false).length > 0 ? <AuraSoftwareSuiteLicensesUnassigned auraSoftwareSuiteLicenses={getLicensesByPartner(false)} updateLicenses={updateLicenses} partners={partner}/> : <></>
                    }
                </div>
            </FlushAccordion>
        </>
        </>
    );
}

export default AuraSoftwareSuiteLicenses;